import { InfoField, NO_PLACEHOLDER, YES_PLACEHOLDER } from '@occc-app/design-system';

import {
  Activate_Payment_Method,
  ConstraintFragment,
  Payment_Method_Evaluation_Method,
} from '@occc/graphql';
import { pluralize } from '@occc-app/lib/strings';
import { getConstraintsByType } from '../constraints-section.utils';
import { activatePaymentMethodLabels } from '../constants';
import { formatValues } from '../../formatters';

const mapPaymentMethodToPaymentMethodLabel = (method: Activate_Payment_Method) =>
  activatePaymentMethodLabels[method];

export const PaymentMethodConstraint = ({ constraints }: { constraints: ConstraintFragment[] }) => {
  const cst = getConstraintsByType('ConstraintPaymentMethod', constraints);
  const allMethods = cst.flatMap((c) => c.paymentMethods ?? []);

  if (allMethods.length === 1 && allMethods[0] === Activate_Payment_Method.MobileApp) {
    return (
      <InfoField
        label='Mobile App Only'
        value={
          cst[0].paymentEvaluationMethod === Payment_Method_Evaluation_Method.Include
            ? YES_PLACEHOLDER
            : NO_PLACEHOLDER
        }
      />
    );
  }

  const titles = formatValues(allMethods.map(mapPaymentMethodToPaymentMethodLabel));
  const evaluationLabel =
    cst[0]?.paymentEvaluationMethod === Payment_Method_Evaluation_Method.Exclude ? 'exclude' : '';

  return (
    <InfoField
      label={`${pluralize(allMethods.length || undefined, 'Payment Method')} ${evaluationLabel}`}
      value={titles}
    />
  );
};
